var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtmChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 28,
    viewBox: "0 0 66 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.425915,
    y: 0.80238,
    width: 34.4383,
    height: 26.0359,
    rx: 1.57408,
    fill: "#AC8204",
    stroke: "white",
    strokeWidth: 0.851831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 8.64771H10.1304C11.2349 8.64771 12.1304 9.54314 12.1304 10.6477V15.1268M12.1304 26.7339V21.6058M12.1304 21.6058V15.1268M12.1304 21.6058H0.550781M12.1304 15.1268H0.550781",
    stroke: "white",
    strokeWidth: 0.851831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7383 8.6477H23.7101M23.7101 8.6477V15.1267M23.7101 8.6477V0.927979M23.7101 26.7339V21.6058M23.7101 21.6058V15.1267M23.7101 21.6058H34.7383M23.7101 15.1267H34.7383",
    stroke: "white",
    strokeWidth: 0.851831
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6018 17.865L49.5982 17.8699L49.5947 17.8748C49.4005 18.1499 48.9653 18.2307 48.6249 17.9904C48.3525 17.7979 48.2706 17.3692 48.5026 17.0304C48.8487 16.5891 49.1001 16.0733 49.2652 15.569C49.4371 15.0441 49.5171 14.4475 49.514 13.8624C49.5108 13.2774 49.4245 12.6817 49.2471 12.1586C49.0766 11.6561 48.8197 11.143 48.4689 10.7055C48.2333 10.3691 48.3107 9.93954 48.581 9.74423C48.9188 9.50026 49.3548 9.57645 49.552 9.84943L49.5555 9.85433L49.5592 9.85914C49.9958 10.4349 50.354 11.0746 50.568 11.7023C50.7933 12.4406 50.9368 13.1548 50.9405 13.8549C50.9444 14.5915 50.874 15.2888 50.6037 15.9752C50.3093 16.7227 50.0242 17.2956 49.6018 17.865ZM52.7589 19.2324L52.7674 19.2203L52.7753 19.2077C53.743 17.6572 54.3013 15.7862 54.2909 13.837C54.2805 11.8883 53.7027 10.0238 52.7189 8.48388C52.5057 8.1458 52.6015 7.74606 52.9608 7.48648C53.2022 7.31214 53.6552 7.37387 53.9241 7.73414C55.0348 9.49641 55.7057 11.6267 55.7174 13.8294C55.7296 16.1073 55.0819 18.1685 53.989 19.9436C53.7362 20.2916 53.3491 20.3891 53.0154 20.1919C52.6535 19.9267 52.5874 19.4752 52.7589 19.2324ZM58.4242 5.4178L58.4337 5.43663L58.4448 5.45462C59.9498 7.9084 60.7862 10.7388 60.8025 13.8023C60.8188 16.8645 60.0134 19.7024 58.5358 22.1713C58.4215 22.3552 58.2674 22.4724 58.0929 22.5202C57.7275 22.6202 57.2981 22.381 57.205 22.0138C57.1616 21.8427 57.1844 21.6527 57.2758 21.4618C58.5324 19.2301 59.3138 16.6004 59.2989 13.8103C59.2841 11.0327 58.5578 8.40718 57.1918 6.17539C57.101 5.9882 57.0769 5.80138 57.1172 5.63217C57.2053 5.26198 57.6318 5.02476 58.0032 5.1074C58.1929 5.14959 58.346 5.2635 58.4242 5.4178ZM62.8806 3.08259L62.8871 3.09546L62.8943 3.10794C64.7182 6.26058 65.7897 9.86497 65.8106 13.7757C65.8314 17.6823 64.8004 21.2945 63.0136 24.4641C62.8996 24.645 62.7467 24.7605 62.5739 24.8078C62.2085 24.9078 61.7791 24.6686 61.686 24.3014C61.6429 24.1314 61.6651 23.9427 61.7551 23.753C63.4764 20.8152 64.4033 17.4117 64.384 13.7833C64.3646 10.1455 63.3199 6.7551 61.6512 3.84632C61.4421 3.4217 61.5894 3.00582 61.8813 2.85794C62.3097 2.64088 62.7314 2.78823 62.8806 3.08259Z",
    fill: "url(#paint0_linear_16323_452718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16323_452718",
    x1: 57.0204,
    y1: 2.78236,
    x2: 57.138,
    y2: 24.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmChip);
export default __webpack_public_path__ + "static/media/atm-chip.51354518.svg";
export { ForwardRef as ReactComponent };